/**
 * [INPUT]: 依赖 framer-motion reduced-motion、motion/CHART_MOTION 与 dither palette 缓存失效能力
 * [OUTPUT]: 对外提供 useDitherMotion，返回统一入场、bloom 与主题切换 replayToken
 * [POS]: charts 的运行时动画桥，让 Canvas RAF 与 Admin 动画/深浅主题真相源保持同步
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */
import { useSyncExternalStore } from 'react'
import { useReducedMotion } from 'framer-motion'

import { clearPaletteCache } from '@/zinnercms-design-system/dither-kit/palette'
import { CHART_MOTION } from '@/zinnercms-design-system/motion'

let themeRevision = 0
let themeObserver = null
const themeListeners = new Set()

const subscribeTheme = (listener) => {
  themeListeners.add(listener)
  if (!themeObserver) {
    themeObserver = new MutationObserver(() => {
      clearPaletteCache()
      themeRevision += 1
      themeListeners.forEach((notify) => notify())
    })
    themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    })
  }

  return () => {
    themeListeners.delete(listener)
    if (!themeListeners.size) {
      themeObserver?.disconnect()
      themeObserver = null
    }
  }
}

const getThemeRevision = () => themeRevision
const getServerThemeRevision = () => 0

function useDitherMotion(replayToken, overrides) {
  const shouldReduceMotion = useReducedMotion()
  const currentThemeRevision = useSyncExternalStore(
    subscribeTheme,
    getThemeRevision,
    getServerThemeRevision
  )

  const defaults = shouldReduceMotion ? CHART_MOTION.reduced : CHART_MOTION.active
  return {
    animate: overrides.animate ?? defaults.animate,
    animationDuration: overrides.animationDuration ?? defaults.animationDuration,
    bloom: overrides.bloom ?? defaults.bloom,
    bloomOnHover: overrides.bloomOnHover ?? defaults.bloomOnHover,
    replayToken: `${replayToken ?? 0}:${currentThemeRevision}:${shouldReduceMotion ? 'reduce' : 'active'}`,
  }
}

export { useDitherMotion }
